import React from "react";
import { NavLink } from "react-router-dom";
import {
  Home, Activity, Droplets, Waves, Container, Radar, Wind, LayoutGrid, Cpu,
  MapPin, Map as MapIcon, Bell, FileText, Users, ShieldCheck, Router, Award,
  Settings2, Settings, CreditCard, ScrollText,
} from "lucide-react";

const all = [
  { to: "/dashboard", label: "Dashboard", icon: Home },
  { to: "/live-monitor", label: "Live Monitor", icon: Activity },
  { to: "/graphical", label: "Graphical Dashboard", icon: Activity },
  { to: "/hydrant", label: "Hydrant System", icon: Droplets },
  { to: "/sprinkler", label: "Sprinkler System", icon: Waves },
  { to: "/tank", label: "Fire Water Tank", icon: Container },
  { to: "/detection", label: "Detection System", icon: Radar },
  { to: "/ventilation", label: "Ventilation System", icon: Wind },
  { to: "/panels", label: "Panels Management", icon: LayoutGrid },
  { to: "/devices", label: "Device Management", icon: Cpu },
  { to: "/sites", label: "Site Management", icon: MapPin },
  { to: "/floors", label: "Floor Plans", icon: MapIcon },
  { to: "/alerts", label: "Alert Management", icon: Bell },
  { to: "/reports", label: "Reports & Logs", icon: FileText },
  { to: "/audit", label: "Audit Log", icon: ScrollText },
  { to: "/users", label: "User Management", icon: Users },
  { to: "/billing", label: "Billing & Plan", icon: CreditCard },
  { to: "/roles", label: "Roles & Permissions", icon: ShieldCheck },
  { to: "/gateway", label: "IoT Gateway", icon: Router },
  { to: "/certificate", label: "ACMS Certificate", icon: Award },
  { to: "/controller", label: "Controller", icon: Settings2 },
  { to: "/settings", label: "System Settings", icon: Settings },
];

export default function MoreMenu() {
  return (
    <div className="md:hidden p-4 pb-24 space-y-2" data-testid="more-menu">
      <h1 className="text-2xl font-extrabold mb-4">All Sections</h1>
      {all.map((m) => {
        const Icon = m.icon;
        return (
          <NavLink key={m.to} to={m.to} className="glass p-4 rounded-lg flex items-center gap-3 hover:border-orange-500/30">
            <Icon className="w-5 h-5 text-orange-400" />
            <span className="font-medium">{m.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
}
